export enum EquipmentOwner {
	DTE = 'DTE',
	OtherUtility = 'OtherUtility',
	Customer = 'Customer',
}
